import React from 'react';

export default class ToolbarComponent extends React.Component {
    render() {
        return (
            <div className="navbar">
                <div className="navbar-brand">
                    <div className="navbar-item">
                        <h1>Registros de cliente</h1>
                    </div>
                </div>
                <div className="navbar-menu is-active">
                    <div className="navbar-item">
                        <div className="field has-addons">
                            <div className="control">
                                <input className="input" onChange={this.props.onChange} type="text" placeholder="Buscar" />
                            </div>
                            <div className="control">
                                <a className="button is-link">
                                    <i className="fas fa-search"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/components/toolbar/index.js